<template>
    <div class="f-official-base-info">
        <!-- 官方流程状态展示 -->
        <div class="f-official-base-info-process">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.OfficialProcess"
                :isrequired="NotRequired">
            </info-icon>
            <span>{{matchOfficialProcess}}</span>
            <veui-button ui="primary"
                v-if="canChangeIssueProcess"
                class="f-official-base-info-btn"
                @click="toggle()">
                更改
            </veui-button>
        </div>

        <!-- 分配技术支持人员 -->
        <div class="f-official-base-info-duty">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.DutyStaff"
                :isrequired="NotRequired">
            </info-icon>

            <staff-assign></staff-assign>
        </div>

        <!-- icafe链接 -->
        <!-- <div v-if="officialinfo.icafeUrl" -->
        <div v-if="true"
            class="f-official-base-info-icafe-link">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.IcafeLink"
                :isrequired="NotRequired">
            </info-icon>
            <a :href="officialinfo.icafeUrl"
                target="_blank">{{officialinfo.icafeUrl}}</a>
        </div>

        <!-- 身份失效提示 -->
        <div v-if="isLostOfficial" class="f-official-base-info-lost-tip">
            <span>{{lostOfficialUser}}</span>
            <span>{{showTips.officialOperationLost}}</span>
        </div>

        <!-- 审核通过提示-->
        <div class="f-official-base-info-audit-desc"
            v-if="isClosed">
            <div class="f-official-base-info-audit-desc-info">
                <span>您提交的回复已由</span>
                <span>{{officialinfo.auditUserInfoLast.nickname}}</span>
                <span>于</span>
                <span>{{officialinfo.auditPassTime}}</span>
                <span>审核通过</span>
            </div>
        </div>

        <veui-confirm-box
            v-if="canChangeProcess"
            :open.sync="canChangeProcess"
            @ok="changeIssueProcess"
            @cancel="cancelChangeIssueProcess"
        >
            <div @click="notAllowScroll">
                <span style="margin-right: 20px;">处理状态</span>
                <veui-select
                    v-model="selectedIssueProcess"
                    :options="issueProcessOptions"
                    @change="notAllowScroll"
                />
            </div>
        </veui-confirm-box>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/base-info.less';
</style>

<script>
import {Button, ConfirmBox, Select} from 'veui';
import {officialProcessMap} from '../../../../store/common/state/utils/constants';
import {mapState, mapGetters} from 'vuex';
import InfoIcon from './InfoIcon.vue';
import StaffAssign from './StaffAssign.vue';

import {throttle} from '@/utils/debounceThrottle';
import {notAllowScroll} from '@/utils/decorate/scroll';

export default {
    props: {
        isExpand: Boolean,
        process: String
    },
    components: {
        'info-icon': InfoIcon,
        'staff-assign': StaffAssign,
        'veui-confirm-box': ConfirmBox,
        'veui-select': Select,
        'veui-button': Button,
    },
    data() {
        return {
            // NotRequired: false
            NotRequired: true,
            selectedIssueProcess: this.process
        };
    },
    computed: {
        matchOfficialProcess() {
            return officialProcessMap[this.topicInfo.process];
        },
        ...mapState({
            OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo,
            lostOfficialUser: state => state.topicContent.lostOfficialUser,
            showTips: state => state.topicContent.showTips,
            topicInfo: state => state.topicContent.topicData.topicInfo,
            canChangeProcess: state => state.topicContent.canChangeProcess
        }),
        ...mapGetters([
            'isClosed',
            'isLostOfficial',
            'canChangeIssueProcess',
            'issueProcessOptions'
        ])
    },

    methods: {
        notAllowScroll,

        toggle() {
            this.$store.dispatch('toggle', 'canChangeProcess');
        },

        changeIssueProcess: throttle(function () {
            this.$store.dispatch('changeIssueProcess', this.selectedIssueProcess);
            this.toggle();
        }),
        cancelChangeIssueProcess() {
            this.toggle();
            this.selectedIssueProcess = this.officialinfo.process;
        }
    }
};
</script>

